import { Cell } from '@pelckmans/elementis/components/table/cell';
import { Score } from '../../../api/results';
import { ScorableItem } from '../../../api/scorable-items';

export default function AbsoluteScoreCell({
  scorableItem,
  score,
}: {
  scorableItem: ScorableItem;
  score?: Score['score'];
}) {
  const showAbsoluteScore = scorableItem.showPoints && score?.maximum;

  return <Cell>{showAbsoluteScore ? <Cell.Text title={`${score.achieved} / ${score.maximum}`} /> : null}</Cell>;
}
